import React, { useState } from "react";
import axios from "axios";
import "./Auth.css";
import Button from "../components/Button";

import { API_BASE } from "../utils/apiConfig";

export default function ForgotPassword({ onAuth, initialEmail = "" }) {
  const [email, setEmail] = useState(initialEmail);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!email) return;

    try {
      setLoading(true);
      await axios.post(`${API_BASE}/auth/forgot-password`, { email });
      setSent(true);
    } catch {
      setSent(true); // always succeed silently
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card single">
        <div className="auth-right center">
          {!sent ? (
            <>
              <h2>Reset password</h2>
              <p className="subtitle">
                Enter your email to receive reset instructions.
              </p>

              <div className="input-group">
                <input
                  placeholder="Email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <Button
                className="primary-btn"
                onClick={submit}
                loading={loading}
              >
                Send reset email
              </Button>
            </>
          ) : (
            <>
              <h2>Check your inbox</h2>
              <p className="subtitle">
                If an account exists, a password reset link has been sent.
              </p>
              <button className="primary-btn" onClick={() => onAuth("login")}>
                Back to login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
